:host {
  font-family: var(--font-family);
  font-size: var(--font-size);
  --max-width: 1080px;
}

.viewport-margins {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 1em;
}

.website-footer {
  background-size: cover;
  color: var(--color-fg-subtle-on-emphasis);
}

.website-footer a {
  color: var(--color-fg-subtle-on-emphasis);
}

.website-footer__content {
  padding: 3em 0;
}

.website-footer__links-container {
  display: flex;
  gap: 3em;
  flex-wrap: wrap;
}

.website-footer__links-container > section {
  min-width: 12em;
}

.website-footer__heading {
  font-size: 0.8em;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 1em;
}

.website-footer__links {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.75em
}

.website-footer__links a {
  text-decoration: none;
}

.website-footer__links a:hover {
  text-decoration: underline;
  text-underline-offset: .15em;
}

.website-footer__footer {
  padding: 1em 0;
  background: rgba(1, 31, 91, 0.8);
}

.website-footer__links--footer {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  flex-direction: row;
  margin-left: -0.5em;
}

.website-footer__links--footer a {
  display: inline-block;
  padding: 0.5em;
  text-transform: uppercase;
  font-size: 0.8em;
  letter-spacing: 0.075em;
  font-weight: 600;
}

.website-footer__links--footer a:hover {
  text-decoration: underline;
}